import { render, staticRenderFns } from "./AppHead.vue?vue&type=template&id=37b57646"
import script from "./AppHead.vue?vue&type=script&lang=js"
export * from "./AppHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports